import styles from "../../../../styles.module.scss";
import dayjs from "dayjs";

import { MergedColumnType } from "../../../types";
import { createColumn } from "../../utils";
//UI
import type { ColumnType, ColumnsType } from "antd/es/table";
import Checkbox from "antd/lib/checkbox";

import { FilterFilled } from "@ant-design/icons";
import classNames from "classnames";

export const actionsWithDocumentsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[]
) => [
  createColumn(intl("code"), "Code", 100, getColumnSearchProps, (a, b) =>
    a.Code?.localeCompare(b.Code)
  ),
  createColumn(
    intl("action-stage"),
    "Name",
    400,
    getColumnSearchProps,
    (a, b) => a.Name?.localeCompare(b.Name)
  ),
  createColumn(intl("notes"), "Prim", 350, getColumnSearchProps, (a, b) =>
    a.Prim?.localeCompare(b.Prim)
  ),
  createColumn(
    intl("content-action-stage"),
    "content",
    400,
    getColumnSearchProps,
    (a, b) => a.content?.localeCompare(b.content)
  ),
  {
    title: intl("control-action"),
    dataIndex: "isKontrol",
    key: "isKontrol",
    align: "center" as const,
    ellipsis: true,
    width: 200,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.isKontrol}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isKontrol === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("track-the-deadline"),
    dataIndex: "isExec",
    key: "isExec",
    align: "center" as const,
    ellipsis: true,
    width: 200,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.isExec}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isExec === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  createColumn(
    intl("set-date-execution"),
    "KolvoDayExec",
    200,
    getColumnSearchProps,
    (a, b) => a.KolvoDayExec - b.KolvoDayExec
  ),
  {
    title: intl("mandatory-entry-file"),
    dataIndex: "DoFile",
    key: "DoFile",
    align: "center" as const,
    ellipsis: true,
    width: 200,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.DoFile}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.DoFile === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("fill-execution-date"),
    dataIndex: "AddDateKFactAfterGet",
    key: "AddDateKFactAfterGet",
    align: "center" as const,
    ellipsis: true,
    width: 200,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.AddDateKFactAfterGet}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.AddDateKFactAfterGet === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  createColumn(
    intl("use-for-document-types"),
    "ConstTypeDocName",
    300,
    getColumnSearchProps,
    (a, b) => a.ConstTypeDocName?.localeCompare(b.ConstTypeDocName)
  ),
  createColumn(
    intl("fill-by-default-for-document-types"),
    "ConstTypeDocNameDef",
    200,
    getColumnSearchProps,
    (a, b) => a.ConstTypeDocNameDef?.localeCompare(b.ConstTypeDocNameDef)
  ),
  {
    title: intl("fill-controlling-person"),
    dataIndex: "AddControllersFromInsertStep",
    key: "AddControllersFromInsertStep",
    align: "center" as const,
    ellipsis: true,
    width: 200,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.AddControllersFromInsertStep}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.AddControllersFromInsertStep === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("enter-mailing-list-after-document-registration"),
    dataIndex: "AddToReestrSendAsDoc",
    key: "AddToReestrSendAsDoc",
    align: "center" as const,
    ellipsis: true,
    width: 200,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.AddToReestrSendAsDoc}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.AddToReestrSendAsDoc === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("allowed-edit-the-file"),
    dataIndex: "IsEditFile",
    key: "IsEditFile",
    align: "center" as const,
    ellipsis: true,
    width: 200,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.IsEditFile}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.IsEditFile === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },

  // createColumn(
  //   intl("date-of-approval"),
  //   "ApprovalDate",
  //   undefined,
  //   getColumnSearchProps,
  //   (a, b) => {
  //     const dateA = a.ApprovalDate
  //       ? dayjs(a.ApprovalDate, "DD.MM.YYYY")
  //       : dayjs(0);
  //     const dateB = b.ApprovalDate
  //       ? dayjs(b.ApprovalDate, "DD.MM.YYYY")
  //       : dayjs(0);
  //     return dateA.diff(dateB);
  //   }
  // ),
];

export const nomenclatureOfCasesCurrentColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[]
) => [
  {
    title: intl("valid"),
    dataIndex: "isActive",
    key: "isActive",
    align: "center" as const,
    width: 100,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.isActive}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isActive === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  createColumn(
    intl("structural-unit"),
    "NAME_OTDEL",
    400,
    getColumnSearchProps,
    (a, b) => a.NAME_OTDEL?.localeCompare(b.NAME_OTDEL)
  ),
  createColumn("№", "ReestrNum", 100, getColumnSearchProps, (a, b) =>
    a.ReestrNum?.localeCompare(b.ReestrNum)
  ),
  createColumn(
    intl("year"),
    "ReestrDate",
    80,
    getColumnSearchProps,
    (a, b) => a.ReestrDate - b.ReestrDate
  ),
  createColumn(
    intl("date-of-approval"),
    "ApprovalDate",
    190,
    getColumnSearchProps,
    (a, b) => {
      const dateA = a.ApprovalDate
        ? dayjs(a.ApprovalDate, "DD.MM.YYYY")
        : dayjs(0);
      const dateB = b.ApprovalDate
        ? dayjs(b.ApprovalDate, "DD.MM.YYYY")
        : dayjs(0);
      return dateA.diff(dateB);
    }
  ),
  createColumn(
    intl("document"),
    "ApprovalDoc",
    300,
    getColumnSearchProps,
    (a, b) => a.ApprovalDoc?.localeCompare(b.ApprovalDoc)
  ),
  createColumn(
    intl("notes"),
    "ApprovalDescription",
    300,
    getColumnSearchProps,
    (a, b) => a.ApprovalDescription?.localeCompare(b.ApprovalDescription)
  ),
  {
    title: intl("add-num-nomenclature"),
    dataIndex: "isAddNum",
    key: "isAddNum",
    align: "center" as const,
    ellipsis: true,
    width: 140,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.isAddNum}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isAddNum === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("add-letter-c"),
    dataIndex: "isAddC",
    key: "isAddC",
    align: "center" as const,
    ellipsis: true,
    width: 140,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.isAddC}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isAddC === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  createColumn(
    intl("general-notes"),
    "Description",
    300,
    getColumnSearchProps,
    (a, b) => a.Description?.localeCompare(b.Description)
  ),
];

export const nomenclatureOfCasesColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>
) => [
  createColumn(
    intl("index"),
    "Code_OfficialDoc",
    100,
    getColumnSearchProps,
    (a, b) => a.Code_OfficialDoc?.localeCompare(b.Code_OfficialDoc)
  ),
  createColumn(
    intl("heading"),
    "Name_OfficialDoc",
    500,
    getColumnSearchProps,
    (a, b) => a.Name_OfficialDoc?.localeCompare(b.Name_OfficialDoc)
  ),
  createColumn(
    intl("shelf-life"),
    "LimitationText",
    180,
    getColumnSearchProps,
    (a, b) => a.LimitationText?.localeCompare(b.LimitationText)
  ),
  createColumn(
    intl("notes"),
    "Prim_OfficialDoc",
    350,
    getColumnSearchProps,
    (a, b) => a.Prim_OfficialDoc?.localeCompare(b.Prim_OfficialDoc)
  ),
  createColumn(
    intl("year"),
    "ReestrDate",
    100,
    getColumnSearchProps,
    (a, b) => +a.ReestrDate - +b.ReestrDate
  ),
  createColumn(
    intl("structural-unit"),
    "NAME_OTDEL",
    350,
    getColumnSearchProps,
    (a, b) => a.NAME_OTDEL?.localeCompare(b.NAME_OTDEL || "")
  ),
];

export const resolutionTemplatesColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>
) => [
  createColumn(
    intl("text-resolution"),
    "text_rezoluzia",
    400,
    getColumnSearchProps,
    (a, b) => a.text_rezoluzia?.localeCompare(b.text_rezoluzia)
  ),
  createColumn(
    intl("performers"),
    "str_FioEcecuters",
    600,
    getColumnSearchProps,
    (a, b) => a.str_FioEcecuters?.localeCompare(b.str_FioEcecuters)
  ),
  createColumn(intl("author"), "fio", 400, getColumnSearchProps, (a, b) =>
    a.fio?.localeCompare(b.fio)
  ),
];

export const executorsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>
) => [
  createColumn(
    intl("by-order"),
    "num_pp",
    200,
    getColumnSearchProps,
    (a, b) => a.num_pp - b.num_pp
  ),
  createColumn(
    intl("performer"),
    "ExecutorFIO",
    undefined,
    getColumnSearchProps,
    (a, b) => a.ExecutorFIO?.localeCompare(b.ExecutorFIO)
  ),
];

export const resultsOfActionsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[]
) => [
  createColumn(intl("code"), "Code", 90, getColumnSearchProps, (a, b) =>
    a.Code?.localeCompare(b.Code)
  ),
  createColumn(intl("name"), "Name", 600, getColumnSearchProps, (a, b) =>
    a.Name?.localeCompare(b.Name)
  ),
  {
    title: intl("fill-in-the-content-of-the-response"),
    dataIndex: "alwaysTextResult",
    key: "alwaysTextResult",
    align: "center" as const,
    ellipsis: true,
    width: 250,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.alwaysTextResult}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.alwaysTextResult === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  createColumn(
    intl("notes"),
    "Notes",
    undefined,
    getColumnSearchProps,
    (a, b) => a.Notes?.localeCompare(b.Notes)
  ),
];

// Компонент для створення колонок в таблицю
export const documentCharColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[],
  data?: MergedColumnType[],
  visible?: boolean
) => {
  return [
    createColumn(intl("code"), "Code", 100, getColumnSearchProps, (a, b) =>
      a.Code?.localeCompare(b.Code)
    ),
    createColumn(
      intl("name"),
      "Name",
      undefined,
      getColumnSearchProps,
      (a, b) => a.Name?.localeCompare(b.Name)
    ),
    createColumn(
      intl("notes"),
      "Notes",
      700,
      getColumnSearchProps,
      (a, b) => a.Notes?.localeCompare(b.Notes)
    ),
    visible && {
      title: intl("deleted"),
      dataIndex: "del",
      key: "del",
      align: "center" as const,
      width: 150,
      ellipsis: true,
      render: (_: any, record: MergedColumnType) => (
        <Checkbox
          className={styles["checkbox"]}
          checked={!!record.del}
          disabled
        />
      ),
      filters,
      onFilter: (value: any, record: MergedColumnType) =>
        !!record.del === value,
      filterIcon: (filtered: boolean) => (
        <FilterFilled
          className={classNames(styles["filter-icon"], {
            [styles["filter-icon--active"]]: filtered,
          })}
        />
      ),
    },
  ].filter(Boolean) as ColumnsType<MergedColumnType>;
};

export const typesOfReceiptsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[]
) => [
  createColumn(intl("code"), "Code", 60, getColumnSearchProps, (a, b) =>
    a.Code?.localeCompare(b.Code)
  ),
  createColumn(intl("name"), "Name", 400, getColumnSearchProps, (a, b) =>
    a.Name?.localeCompare(b.Name)
  ),
  createColumn(intl("notes"), "Note", 250, getColumnSearchProps, (a, b) =>
    a.Note?.localeCompare(b.Note)
  ),
  // createColumn(intl("user"), "name_user", 200, getColumnSearchProps, (a, b) =>
  //   a.Name?.localeCompare(b.Name)
  // ),
];
